import {AsyncSearchState, SearchProgressStage} from '@features/search/interfaces';

export function getDefaultAsyncSearchModel(showResults: () => void) {
    return {
        showResults: showResults,
        state: AsyncSearchState.None,
        length: 0,
        progressStage: SearchProgressStage.None
    };
}
